import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default function lifecycle(initializeFromProps, cleanUpFromProps) {
    return (Component) => {
        class InnerComponent extends React.Component {
            componentDidMount() {
                if (initializeFromProps) {
                    initializeFromProps(this.props);
                }
            }
            componentWillUnmount() {
                if (cleanUpFromProps) {
                    cleanUpFromProps(this.props);
                }
            }
            render() {
                return _jsx(Component, { ...this.props });
            }
        }
        return InnerComponent;
    };
}
